<template>
    <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
      <div class="aside-inner">
        <div class="aside-inner-title">상품</div>
        <div class="accordion" id="accordionExample">
          <template v-for="depth1 in state.SnbDepth1" :key="depth1.key" >
            <template v-if="depth1.access">

              <div class="accordion-item">
                <h2 class="accordion-header">
                  <ElButton type="accordionSide" :target="depth1.key">
                    {{ depth1.name }}
                  </ElButton>
                </h2>
                <div :id="depth1.key" :class="[state.keyStatus === depth1.key ? 'accordion-collapse collapse show' : 'accordion-collapse collapse']">
                  <div class="accordion-body">
                    <ul class="accordion-submenu">
                      <template v-for="item in state.snbDepth2" :key="item.key">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link 
                            :to="item.link"
                          >
                            {{ item.name }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </template> 
          

        </div>
      </div>      
    </div>
   
  </template>
  
<script setup>
import { router } from '@/router';
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
const route = useRoute()
const userStore = useUserStore()
  
const state = computed(()=>{
  const data = {
      SnbDepth1 :[
          {key : 'im1',name:'상품 분류기준 관리',link:'',id:'M005',access:false},
      ],
      snbDepth2 : [
          {key : 'im1',name:'상품 분류체계 등록/수정', link : '/im/MIM_CL_001',id:'M005M001',access:false},
          {key : 'im1',name:'상품 분류체계 조회', link : '/im/MIM_CL_003',id:'M005M003',access:false},
          {key : 'im1',name:'상품 분류체계 이력 조회', link : '/im/MIM_CL_002',id:'M005M002',access:false},
          {key : 'im1',name:'상품 분류체계 맵핑 화면', link : '/im/MIM_CL_004',id:'M005M004',access:false},
          {key : 'im1',name:'상품버전 회계연도매핑', link : '/im/MIM_CL_005',id:'M005M005',access:false},
          {key : 'im1',name:'영업기회 상품정보 일괄수정', link : '/im/MIM_CL_006',id:'M005M006',access:false},
      ],
    keyStatus : ''
  }


  const menuList = Object.keys(data).filter(name => name.includes('Depth'))

  menuList.forEach((depth)=>{
    data[depth].forEach((item)=>{
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })


  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link.toLowerCase() === route.path.toLowerCase()) {
        if(userStore.user && !item.access){
          alert('접근 불가한 페이지입니다.')
          router.push('/')
          return
        }
        data.keyStatus = item.key
      }
    })
  })



  return data
})
  
</script>